import { render, staticRenderFns } from "./BoardUpdate.vue?vue&type=template&id=2a26084d&scoped=true&"
import script from "./BoardUpdate.vue?vue&type=script&lang=js&"
export * from "./BoardUpdate.vue?vue&type=script&lang=js&"
import style0 from "./BoardUpdate.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BoardUpdate.vue?vue&type=style&index=1&id=2a26084d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a26084d",
  null
  
)

export default component.exports